import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  SubscribePlanChangeUpgradeGet200,
  SubscribePlanChangeUpgradeGetParams
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary 플랜 업그레이드 정보 조회
 */
export const subscribePlanChangeUpgradeGet = (
    params: SubscribePlanChangeUpgradeGetParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SubscribePlanChangeUpgradeGet200>(
      {url: `/api/v1/subscribe/plan-change/upgrade`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSubscribePlanChangeUpgradeGetQueryKey = (params: SubscribePlanChangeUpgradeGetParams,) => {
    return [`/api/v1/subscribe/plan-change/upgrade`, ...(params ? [params]: [])] as const;
    }

    
export const getSubscribePlanChangeUpgradeGetInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>, TError = unknown>(params: SubscribePlanChangeUpgradeGetParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubscribePlanChangeUpgradeGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>> = ({ signal }) => subscribePlanChangeUpgradeGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>, TError, TData> & { queryKey: QueryKey }
}

export type SubscribePlanChangeUpgradeGetInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>>
export type SubscribePlanChangeUpgradeGetInfiniteQueryError = unknown

/**
 * @summary 플랜 업그레이드 정보 조회
 */
export const useSubscribePlanChangeUpgradeGetInfinite = <TData = Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>, TError = unknown>(
 params: SubscribePlanChangeUpgradeGetParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSubscribePlanChangeUpgradeGetInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSubscribePlanChangeUpgradeGetQueryOptions = <TData = Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>, TError = unknown>(params: SubscribePlanChangeUpgradeGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubscribePlanChangeUpgradeGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>> = ({ signal }) => subscribePlanChangeUpgradeGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>, TError, TData> & { queryKey: QueryKey }
}

export type SubscribePlanChangeUpgradeGetQueryResult = NonNullable<Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>>
export type SubscribePlanChangeUpgradeGetQueryError = unknown

/**
 * @summary 플랜 업그레이드 정보 조회
 */
export const useSubscribePlanChangeUpgradeGet = <TData = Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>, TError = unknown>(
 params: SubscribePlanChangeUpgradeGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof subscribePlanChangeUpgradeGet>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSubscribePlanChangeUpgradeGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



